import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardOverview from './dashboard/Overview';
import UserOverview from './users/overview/Overview';
import UserDetails from './users/details/Details';
import ADFSSubSettings from './administration/ADFSConfig/ADFSSubSettings';
import { LicenseOverview } from './licenses/overview/Overview';
import LicenseDetails from './licenses/details/Details';
import TaskOverview, { IncompleteTasksBadgeContent } from './tasks/overview/Overview';
import TaskIcon from '@mui/icons-material/Assignment';
import OrderOverview from './orders/overview/Overview';
import { RouteDef, Shell } from './shell/Shell';
import { Folders } from './discounts/overview/Folder';
import { Discounts } from './discounts/overview/overview';
import { DiscountDetails } from './discounts/details/Details';
import { NewDiscount } from './discounts/overview/NewDiscount';
import { RenewalOverview } from './renewals/Overview';
import { Overview as ReportOverview } from './reports/Overview';
import { Overview as SubscriptionOverview } from './subscriptions/overview';
import { Overview as Administration } from './administration/overview';
import { Dashboard, Group, Business, ShoppingBasket, NewReleases, Sync, TrendingDown, LocalOffer, Settings } from '@mui/icons-material';
import GeneralSettings from './administration/ADFSConfig/GeneralSettings';
import AdvanceSettings from './administration/ADFSConfig/AdvanceSettings';
import ADFSClientAuthorization from './administration/ADFSConfig/ADFSClientAuthorization';
import CompanyDetail from './reports/guides/CompanyDetail';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const CompanyDetailWrapper: FC = () => {
  const { orgNumber, companyName } = useParams<{ orgNumber: string; companyName: string }>();
  const navigate = useNavigate();
  return (
    <CompanyDetail
      orgNumber={orgNumber!}
      companyName={decodeURIComponent(companyName!)}
      onBackClick={() => navigate(-1)}
    />
  );
};
const routes: RouteDef[] = [
  { path: '/', element: <DashboardOverview />, title: 'Dashboard', icon: <Dashboard /> },
  { path: '/license', element: <LicenseOverview />, title: 'Kunder', icon: <Business /> },
  { path: '/license/:id', element: <LicenseDetails /> },
  { path: '/adfssubsetting/:bksID', element: <ADFSSubSettings /> },
  { path: '/authorization/', element: <ADFSClientAuthorization /> },
  { path: '/advancesetting/', element: <AdvanceSettings /> },
  { path: '/generalsetting', element: <GeneralSettings /> },
  { path: '/user', element: <UserOverview />, title: 'Brukere', icon: <Group /> },
  { path: '/user/:id', element: <UserDetails /> },
  {
    path: '/task',
    element: <TaskOverview />,
    title: 'Oppgaver',
    icon: (
      <IncompleteTasksBadgeContent>
        <TaskIcon />
      </IncompleteTasksBadgeContent>
    ),
  },
  { path: '/order', element: <OrderOverview />, title: 'Ordre', icon: <ShoppingBasket /> },
  { path: '/folders', element: <Folders />, title: 'Rabatter', icon: <NewReleases /> },
  { path: '/discounts/:id', element: <Discounts /> },
  { path: '/discount/new', element: <NewDiscount /> },
  { path: '/discount/:id', element: <DiscountDetails /> },
  { path: '/renewal', element: <RenewalOverview />, title: 'Fornyelser', icon: <Sync /> },
  { path: '/report', element: <ReportOverview />, title: 'Rapporter', icon: <TrendingDown /> },
  { path: '/subscription', element: <SubscriptionOverview />, title: 'Priser', icon: <LocalOffer /> },
  { path: '/administrasjon', element: <Administration />, title: 'Administrasjon', icon: <Settings /> },
  { path: '/companydetail/:orgNumber', element: <CompanyDetailWrapper /> },
  { path: '/reports/guides/company/:orgNumber/:companyName', element: <CompanyDetailWrapper /> },
];

const App: FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Shell routes={routes} />
    </LocalizationProvider>
  );
};

export default App;
